// @flow

import areIntlLocalesSupported from 'intl-locales-supported';
import smoothscroll from 'smoothscroll-polyfill';
import {acceptLocales} from './utils/translations';

/**
 * Support Intl on old browser
 */
if (window.Intl) {
  if (!areIntlLocalesSupported(acceptLocales)) {
    const IntlPolyfill = require('intl');
    Intl.NumberFormat = IntlPolyfill.NumberFormat;
    Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
  }
} else {
  window.Intl = require('intl');
}

smoothscroll.polyfill();

// polyfill for async/await
import 'regenerator-runtime/runtime';
